import { render } from "./NotesView.vue?vue&type=template&id=6e42e8c2"
import script from "./NotesView.vue?vue&type=script&lang=js"
export * from "./NotesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__